import React, { useContext } from "react";
import { useSearchParams, useNavigate, useParams } from "react-router-dom";
import { Row } from "react-bootstrap";
import FilterDropdown from "./FilterDropdown";
import { SearchContext } from "./AdSearchManager/SearchContext";

export default function FilterRow({ filter, data, setLookupResults, sectionUrl }) {
    const { searchState } = useContext(SearchContext);
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const { section, slug } = useParams();

    let localItems = filter
        .lookups(searchState.filters, searchState.relations, searchState.freetext);
    if(localItems !== null)
        localItems = localItems.filter((f) => f !== undefined);

    const isFilterDisabled = (filter) => {
        if (filter.header === "HUVUDOMRÅDE" && filter.data.length === 0) return false;
        if (filter.header === "KATEGORIER" && filter.data.length === 0) return false;
        if (filter.header === "UTBILDNINGSTYPER") return false;
        if (filter.header === "LÄN" && filter.data.length === 0) return false;
        if (
            searchState.filters.find((f) => f.header === "HUVUDOMRÅDE").data.length > 0 &&
            filter.header === "UNDERKATEGORIER"
        ) {
            return false;
        }
        if (
            searchState.filters.find((f) => f.header === "LÄN").data.length > 0 &&
            filter.header === "ORT"
        ) {
            return false;
        }
        return true;
    };

    return (
        <Row className="mb-1">
            <FilterDropdown
                disabled={isFilterDisabled(filter)}
                alwaysShow={false}
                dropdownTitle={
                    filter.header === "HUVUDOMRÅDE" && sectionUrl === "traineeprogram" ? "BRANSCH" : filter.header
                }
                onClickInitial={() => {
                    filter.clear();
                    setLookupResults(
                        data.length >= filter.maxCount ? [] : filter.lookups(searchState.filters, searchState.relations)
                    );
                }}
                onClickItem={(value) => {
                    let newData = [...data];
                    if (!newData.includes(value)) {
                        newData.push(value);
                    }
                    filter.data = newData;
                    searchParams.set(filter.filterName, newData.join(";"));
                    if (slug) {
                        navigate(`/${section}?${searchParams.toString()}`);
                    } else {
                        setSearchParams(searchParams);
                    }
                }}
                items={localItems}
                filterHeader={filter.header}
            />
            {data.length > 0 && (
                <ul>
                    {data.map((value) => {
                        return (
                            <>
                                <li style={{ listStyle: "none" }} className="left">
                                    <i
                                        className="far fa-times mr-1 pointer"
                                        onClick={(e) => {
                                            let newData = [...data];
                                            newData = newData.filter((l) => l !== value);
                                            if (newData.length === 0) {
                                                searchParams.delete(filter.filterName);
                                            } else {
                                                searchParams.set(filter.filterName, newData.join(";"));
                                            }
                                            if (slug) {
                                                navigate(`/${section}?${searchParams.toString()}`);
                                            } else {
                                                setSearchParams(searchParams);
                                            }
                                        }}
                                    ></i>
                                    {value}
                                </li>
                            </>
                        );
                    })}
                </ul>
            )}
        </Row>
    );
}
